<script setup lang="ts">
import type { IadAppRoute } from '~/application';

defineEmits<{
  select: []
}>();
const { locale } = useI18n();
const propertipsLink = computed(() => {
  return locale.value === 'fr'
    ? 'https://propertips.com/'
    : 'https://propertips.com/?lang=en_EN';
});

const route = useRoute();
const localePath = useLocalePath();
const onlineValuationLink = computed(() => {
  const valuationRoute: IadAppRoute<'valuation-online-valuation'> = { name: 'valuation-online-valuation', params: {} };
  // Force a hard reload when inside valuation page
  // • this will reset all states
  // • “startsWith” because route name is postfixed with locale
  if (typeof route.name === `string` && route.name.startsWith(`valuation-online-valuation`)) return { href: localePath(valuationRoute, locale.value) };
  valuationRoute.query = { returnTo: route.path };
  return { to: valuationRoute };
});
</script>

<template>
  <div class="flex flex-col gap-xl">
    <MainHeaderMenuItemLink
      variant="submenu"
      :text="$t('core.header.menu.sell_with_iad')"
      :to="{ name: 'valuation' }"
      menu-category1="sell_estimate"
      menu-category2="sell_with_iad"
      @click="$emit('select')"
    />
    <MainHeaderMenuItemLink
      variant="submenu"
      :text="$t('core.header.menu.valuate_apartment')"
      :to="{ name: 'valuation-apartment' }"
      menu-category1="sell_estimate"
      menu-category2="estimate_apartment"
      @click="$emit('select')"
    />
    <MainHeaderMenuItemLink
      variant="submenu"
      :text="$t('core.header.menu.valuate_house')"
      :to="{ name: 'valuation-house' }"
      menu-category1="sell_estimate"
      menu-category2="estimate_house"
      @click="$emit('select')"
    />
    <MainHeaderMenuItemLink
      v-if="locale === 'fr'"
      variant="submenu"
      :text="$t('core.header.menu.sale_advices')"
      href="https://blog.iadfrance.fr/conseil-immobilier/vente/"
      target="_blank"
      menu-category1="sell_estimate"
      menu-category2="selling_advices"
      @click="$emit('select')"
    />
    <MainHeaderMenuItemLink
      variant="submenu"
      :text="$t('core.header.menu.recommend_seller')"
      :href="propertipsLink"
      target="_blank"
      menu-category1="sell_estimate"
      menu-category2="help_a_relative"
      @click="$emit('select')"
    />
    <div>
      <IadBtn
        v-if="onlineValuationLink.to"
        :size="'large'"
        :to="onlineValuationLink.to"
        :text="$t('core.menu.header.valuate_online')"
        menu-category1="sell_estimate"
        @click="$emit('select')"
      />
      <IadBtn
        v-else
        :size="'large'"
        :href="onlineValuationLink.href"
        :text="$t('core.menu.header.valuate_online')"
        menu-category1="sell_estimate"
        @click="$emit('select')"
      />
    </div>
  </div>
</template>
